import React, { useState, useEffect, useRef } from 'react';

const History_ = () => {
  const events = [
    { id: 1, date: '2021', title: 'Création', description: 'Création de BMS par Alex et Joel' },
    { id: 2, date: '2021', title: 'Premier Tournoi', description: 'Participation à notre première compétition majeure' },
    { id: 3, date: '2022', title: 'Sur le toit du monde', description: "Victoire de Wawa à l'EVO" },
    { id: 4, date: '2023', title: 'Expension Européenne', description: 'Victoire récurrente contre des tops players dans des compétitions eurpoéennes' },
    { id: 5, date: '2024', title: 'Début du merch au KOF', description: "Mise en vente de notre merch au KoF 2024 qui marque le début d'une nouvelle ère pour BMS"},
  ];

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [visibleEvents, setVisibleEvents] = useState([]);
  const timelineRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('button') && !event.target.closest('[role="dialog"]')) {
        setSelectedEvent(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          events.forEach((event, index) => {
            setTimeout(() => {
              setVisibleEvents(prev => [...prev, event.id]);
            }, index * 600);
          });
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
      }
    );

    if (timelineRef.current) {
      observer.observe(timelineRef.current);
    }

    return () => {
      if (timelineRef.current) {
        observer.unobserve(timelineRef.current);
      }
    };
  }, []);

  const maxWidth = visibleEvents.length > 0 
    ? `${((Math.max(...visibleEvents) / events.length) * 100)}%`
    : '0%';

  return (
    <div 
      ref={timelineRef}
      className="timeline w-full max-w-6xl mx-auto p-4 md:p-12 overflow-y-hidden overflow-x-auto lg:overflow-x-hidden"
      style={{ 
        scrollbarWidth: 'thin',
        scrollBehavior: 'smooth',
        scrollbarColor: '#be185d transparent',
      }}
    >
      <h2 className={`text-2xl md:text-4xl font-bold mb-8 md:mb-16 text-center tracking-tight text-white transition-all duration-700
        ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        Notre Histoire
      </h2>
      
      <div className=" history-container relative w-full">
        <div className="absolute w-full " style={{ height: '32px' }}>
          <div className={`absolute h-0.5 bg-gray-800 w-full top-4 transition-all duration-1000
            ${isInView ? 'opacity-100' : 'opacity-0'}`} 
          />
          
          <div 
            className="absolute h-0.5 bg-white top-4 left-0 transition-all duration-1000"
            style={{ 
              width: maxWidth,
              boxShadow: '0 0 8px rgba(255, 255, 255, 0.5)'
            }}
          />
        </div>

        <div className="relative flex justify-between items-start pt-4">
          {events.map((event, index) => (
            <div 
              key={event.id}
              className={`relative flex flex-col items-center group transition-all duration-700 ease-out w-28 md:w-32
                ${visibleEvents.includes(event.id) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
              `}
            >
              <div className="absolute" style={{ top: '-13px' }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedEvent(selectedEvent?.id === event.id ? null : event);
                  }}
                  className={`w-6 h-6 md:w-8 md:h-8 rounded-full border-4 transition-all duration-300 bg-white
                    ${selectedEvent?.id === event.id 
                      ? 'border-white scale-125' 
                      : 'border-white hover:scale-110'}
                  `}
                  style={{
                    boxShadow: selectedEvent?.id === event.id 
                      ? '0 0 20px #fff, 0 0 30px rgba(255,255,255,0.8)' 
                      : '0 0 15px rgba(255,255,255,0.6)'
                  }}
                />
              </div>
              
              <div className="mt-8 flex flex-col items-center">
                <div className="text-sm md:text-lg font-medium text-white text-center mb-2">{event.date}</div>
                <div className="text-center w-full px-1">
                  <h3 className={`text-xs md:text-base font-semibold transition-colors duration-300 text-center
                    ${selectedEvent?.id === event.id ? 'text-white' : 'text-gray-400 group-hover:text-white'}
                  `}>
                    {event.title}
                  </h3>
                </div>
              </div>

              <div 
                role="dialog"
                onClick={(e) => e.stopPropagation()}
                className={`
                  absolute top-24 md:top-32 w-48 md:w-64 p-4 md:p-6 bg-neutral-900 border border-neutral-800 rounded-xl shadow-2xl
                  transform transition-all duration-300 ease-out z-10 left-1/2 -translate-x-1/2
                  ${selectedEvent?.id === event.id 
                    ? 'opacity-100 translate-y-0' 
                    : 'opacity-0 -translate-y-4 pointer-events-none'}
                `}
              >
                <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 rotate-45 bg-neutral-900 border-t border-l border-neutral-800" />
                <p className="text-gray-300 leading-relaxed text-center text-xs md:text-sm">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex sm:hidden justify-center mt-4">
        <p className="text-gray-400 text-xs">← Faites défiler horizontalement →</p>
      </div>
    </div>
  );
};

const styles = `
  @media (max-width: 1023px) {
    .timeline::-webkit-scrollbar {
      height: 2px;
    }
    .timeline::-webkit-scrollbar-track {
      background: transparent;
    }
    .timeline::-webkit-scrollbar-thumb {
      background: rgba(75, 85, 99, 0.3);
      border-radius: 2px;
    }
  }
`;

const History = ({ ...props }) => {
  return (
    <>
      <style>{styles}</style>
      <History_ {...props} />
    </>
  );
};

export default History;